/**
 * it-add-to-cart.js — Innovadora Tech
 *
 * Un solo listener por delegación de eventos (document, click) para todos
 * los botones ".it-add-to-cart-btn" del sitio (cards nuevas de Catálogo,
 * Más vendidos, Consolas Retro, Productos Tecnológicos y Temporada — mismo
 * snippet compartido, snippets/it-collection-product-card.liquid). No hay
 * un listener por card: uno solo, agregado una vez al cargar este script.
 *
 * Usa fetch() nativo contra /cart/add.js y /cart.js (API AJAX estándar de
 * Shopify, confirmada compatible con este theme y con cart_type:"page" —
 * ambos endpoints funcionan independientemente de ese setting). No navega
 * a /cart ni recarga la página. No modifica el comportamiento del ícono
 * de carrito del header (ese sigue yendo a /cart tal cual).
 *
 * Actualiza el badge ya existente del header (.it-cart-badge /
 * .it-cart-badge__count / clase cart-link__bubble--visible — ver
 * sections/header.liquid) — no crea un segundo badge.
 */
(function () {
  'use strict';

  var SUCCESS_DISPLAY_MS = 1700;
  var ERROR_DISPLAY_MS = 2200;

  function updateCartBadge(itemCount) {
    var counts = document.querySelectorAll('.it-cart-badge__count');
    for (var i = 0; i < counts.length; i++) {
      counts[i].textContent = itemCount;
    }
    var badges = document.querySelectorAll('.it-cart-badge');
    for (var j = 0; j < badges.length; j++) {
      if (itemCount > 0) {
        badges[j].classList.add('cart-link__bubble--visible');
      } else {
        badges[j].classList.remove('cart-link__bubble--visible');
      }
    }
  }

  function setButtonState(button, state) {
    button.classList.remove('is-loading', 'is-success', 'is-error');
    var label = button.querySelector('.it-add-to-cart-btn__label');

    if (state === 'loading') {
      button.classList.add('is-loading');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = button.dataset.loadingLabel || 'Agregando…';
      return;
    }

    if (state === 'success') {
      button.classList.add('is-success');
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (label) label.textContent = button.dataset.successLabel || 'Agregado';
      return;
    }

    if (state === 'error') {
      button.classList.add('is-error');
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (label) label.textContent = button.dataset.errorLabel || 'No se pudo agregar';
      return;
    }

    // idle
    button.disabled = false;
    button.removeAttribute('aria-busy');
    if (label) label.textContent = button.dataset.idleLabel || 'Agregar';
  }

  function addToCart(button) {
    var variantId = button.dataset.variantId;
    if (!variantId) {
      return;
    }

    setButtonState(button, 'loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('add failed');
        }
        return response.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateCartBadge(cart.item_count);
        setButtonState(button, 'success');
        window.setTimeout(function () {
          setButtonState(button, 'idle');
        }, SUCCESS_DISPLAY_MS);
      })
      .catch(function () {
        setButtonState(button, 'error');
        window.setTimeout(function () {
          setButtonState(button, 'idle');
        }, ERROR_DISPLAY_MS);
      });
  }

  document.addEventListener('click', function (evt) {
    var button = evt.target.closest ? evt.target.closest('.it-add-to-cart-btn') : null;
    if (!button) return;
    if (button.disabled) return;
    evt.preventDefault();
    addToCart(button);
  });
})();
